import { Controller } from 'stimulus';

class DynamicVisiblity extends Controller {
  async connect() {

    const [startRange, endRange] = [parseInt(this.data.get('startRange')) || 0, parseInt(this.data.get('endRange')) || 9999];
    this.startRange = startRange;
    this.endRange = endRange;
    this.showOrHide = this.data.get('state') || 'hide';
    this.removePadding();

    window.EventManager.on(this.data.get('event'), () => {
      this.isWithinRange();
      window.onresize = this.isWithinRange;
    })
  }

  isWithinRange = () => {
    const currentWidth = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth)
    if (this.startRange <= currentWidth && this.endRange >= currentWidth) {
      if (this.showOrHide == 'hide') {
        this.hideElement();
      } else {
        this.showElement();
      }
    } else {
      if (this.showOrHide == 'hide') {
        this.showElement();
      } else {
        this.hideElement();
      }
    }
  }

  showElement = () => {
    this.element.style.setProperty('display', '');
    this.element.style.setProperty('padding', '');
  }

  hideElement = () => {
    this.element.style.setProperty('display', 'none', 'important');
  }

  removePadding = () => {
    this.element.style.setProperty('padding', '0px', 'important');
  }
}

export default DynamicVisiblity;
